//baseUrl
const DOMAIN_NAME = {
  // URL_EASYMOCK: 'http://sfj.xueqiusoft.com'
  URL_EASYMOCK: 'https://zgsfxg.com'
}

export default DOMAIN_NAME


// WEBPACK FOOTER //
// ./src/server/config.js